import { RequirementsViewModes } from '@abb-procure/constants';
import { RequirementFields, RequirementModel } from '@abb-procure/data';
import {
  Component,
  DestroyRef,
  OnInit,
  ViewEncapsulation,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { escapeDialog } from '../../utilities/dialog.util';
import { Button } from '../button/button.component';
import { RequirementFieldsSortingGroup } from '../requirements-fields-sorting-group/requirements-fields-sorting-group.component';

export interface RequirementsSettingsDialogData {
  name: string;
  requirementFields: RequirementFields;
  control: FormControl;
  formFields: { [key: string]: string };
}

@Component({
  templateUrl: './requirements-settings-dialog.component.html',
  styleUrl: './requirements-settings-dialog.component.scss',
  imports: [
    MatDialogContent,
    MatTabGroup,
    MatTab,
    Button,
    RequirementFieldsSortingGroup,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class RequirementsSettingsDialog implements OnInit {
  readonly data: RequirementsSettingsDialogData = inject(MAT_DIALOG_DATA);
  prevValues: RequirementFields | undefined;
  commercial =
    this.data?.requirementFields?.commercial?.map(
      (item) => new RequirementModel(item),
    ) ?? [];
  technical =
    this.data?.requirementFields?.technical?.map(
      (item) => new RequirementModel(item),
    ) ?? [];
  logistical =
    this.data?.requirementFields?.logistical?.map(
      (item) => new RequirementModel(item),
    ) ?? [];
  selected: RequirementFields = {
    commercial: [],
    technical: [],
    logistical: [],
  };
  RequirementsViewModes = RequirementsViewModes;

  get name(): string {
    return this.data.name;
  }
  get control(): FormControl {
    return this.data.control;
  }
  get formFields(): { [key: string]: string } {
    return this.data.formFields;
  }

  private readonly dialogRef = inject(
    MatDialogRef<RequirementsSettingsDialog, RequirementFields>,
  );
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    escapeDialog(this.dialogRef, this.destroyRef, () => this.onCancel());

    if (
      this.control.value?.name === RequirementsViewModes.Custom &&
      this.control?.value?.values
    ) {
      const values = this.control?.value?.values;

      this.selected = {
        commercial: values.commercial || [],
        technical: values.technical || [],
        logistical: values.logistical || [],
      };
    }

    this.prevValues = this.selected;
  }

  onSubmit(): void {
    const values = this.selected;
    this.dialogRef.close(values);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSelectedChanged(data: RequirementModel[], reqType: string): void {
    this.selected[reqType as keyof RequirementFields] = data;
  }
}
